import { useCallback, useMemo } from 'react'

import { useRenameConversation } from '@/hooks/use-rename-conversation.hook'

interface UseChatTitleEditParams {
  conversationId: string | null
}

export interface UseChatTitleEditReturn {
  isTitleEditing: boolean
  isTitleSaving: boolean
  handleTitleEditStart: () => void
  handleTitleSave: (newName: string) => void
  handleTitleEditCancel: () => void
}

export const useChatTitleEdit = ({
  conversationId,
}: UseChatTitleEditParams): UseChatTitleEditReturn => {
  const rename = useRenameConversation()

  const isTitleEditing = rename.editingConversationId === conversationId && conversationId !== null
  const isTitleSaving = rename.isRenaming

  const handleTitleEditStart = useCallback(() => {
    if (conversationId) {
      rename.startEditing(conversationId)
    }
  }, [conversationId, rename])

  const handleTitleSave = useCallback(
    (newName: string) => {
      rename.handleSave(newName)
    },
    [rename]
  )

  const handleTitleEditCancel = useCallback(() => {
    rename.cancelEditing()
  }, [rename])

  return useMemo(
    () => ({
      isTitleEditing,
      isTitleSaving,
      handleTitleEditStart,
      handleTitleSave,
      handleTitleEditCancel,
    }),
    [isTitleEditing, isTitleSaving, handleTitleEditStart, handleTitleSave, handleTitleEditCancel]
  )
}
